import { z } from 'zod';

export const uploadedFileSchema = z.object({
    externalUuid: z.uuid(),
    cdnUrl: z.url(),
    cdnUrlModifiers: z.string(),
    name: z.string().min(1),
    size: z.number().nonnegative(),
    mimeType: z.string().min(1),
    isImage: z.boolean(),
    s3Url: z.string().nullable(),
    s3Bucket: z.string().nullable(),
});

export type UploadedFile = z.infer<typeof uploadedFileSchema>;

export const crmAttachmentDtoSchema = uploadedFileSchema.extend({
    attachmentId: z.string(),
});

export type CrmAttachmentDTO = z.infer<typeof crmAttachmentDtoSchema>;
